/** Default GreenTill white-label theme (CMS + receipt baseline). */
export const GREENTILL_STORE_THEME_DEFAULTS = {
  primaryColor: "#1F3B6F",
  secondaryColor: "#4CAF50",
  sidebarColor: "#222437",
  topbarColor: "#ffffff",
  menuHighlightColor: "#10b981",
  menuTextColor: "#cbd5e1",
  accentColor: "#10b981"
};

export default GREENTILL_STORE_THEME_DEFAULTS;
